export type LanguageOption = { translationKey: string; code: string };

export const DEFAULT_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGE_CODES = [
    'en',
    'ar',
    'de',
    'es',
    'fr',
    'ja',
    'lt',
    'ru',
    'pt',
    'ko',
    'nl',
    'pt-BR',
    'zh',
    'hi',
    'th',
    'sk',
    'uz-Latn',
    'he-IL',
    'it',
    'vi',
    'fil',
    'id',
    'fa',
    'uk',
] as const;

export const LANGUAGE_OPTIONS: LanguageOption[] = SUPPORTED_LANGUAGE_CODES.map((code) => ({
    code,
    translationKey: `inside-fifa.languages.${code}`,
}));
